import "../../utils/tailwind.css";
import cx from "../../utils/tailwind-merge";
import Loader from "react-js-loader";

const CustomButton = ({
  children,
  label,
  variant = "default",
  onClick,
  disabled = false,
  isLoading = false,
  className,
  ...props
}) => {
  const baseStyles = "rounded-[10px] text-xs transition-all duration-300 flex items-center justify-center print:hidden ";
  const sizeStyles = "px-4 py-2 min-w-[120px] h-[44px] text-xs font-semibold shadow-md";

  const buttonVariants = {
    default: `${sizeStyles} bg-[#1e1e5c] text-white hover:bg-[#FCBB32] hover:text-[#1e1e5c] border-none`,
    outline: `${sizeStyles} border-2 border-[#1e1e5c] text-[#1e1e5c] hover:bg-[#1e1e5c] hover:text-white`,
    secondary: `${sizeStyles} bg-[#FCBB32] text-[#1e1e5c] hover:bg-[#1e1e5c] hover:text-white border-none`,
    disabled: `${sizeStyles} bg-[#e5e5e5] text-[#999] cursor-not-allowed border-none`,
    link: `text-[16px] font-bold text-[#1e1e5c] hover:text-[#FCBB32] transition-colors p-0 h-fit`,
  };

  const buttonClasses = disabled || isLoading ? buttonVariants.disabled : buttonVariants[variant] || buttonVariants.default;

  return (
    <button
      className={cx(baseStyles, buttonClasses, className)}
      onClick={onClick}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <Loader type="bubble-scale" bgColor={variant === 'outline' ? '#1e1e5c' : 'white'} size={22} />
      ) : (
        children || label
      )}
    </button>
  );
};

export default CustomButton;
